import { MessageService, type Chat, type SendMessageInputWritable } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessageAttachmentUpload = () => {
  const { send: uploadAttachment, isLoading } = useFetchComposable(
    ({
      chatId,
      content,
      files,
      replyToMessageId,
    }: {
      chatId: Chat['id'];
      content: string;
      files: File[];
      replyToMessageId?: SendMessageInputWritable['replyToMessageId'];
    }) =>
      MessageService.sendMessageWithAttachments({
        path: { id: chatId },
        body: { content, files, replyToMessageId },
      }),
  );

  return { uploadAttachment, isLoading };
};

export { useMessageAttachmentUpload };
